import { Overlay, SpinnerIcon } from './Spinner.styled';

export interface SpinnerProps extends React.SVGAttributes<SVGSVGElement> {
  className?: string;
  name?: string;
  size?: number;
  isOverlaying?: boolean;
}

const Spinner = ({
  className,
  isOverlaying,
  name = '',
  size,
  ...rest
}: SpinnerProps) => {
  const spinnerElement = (
    <SpinnerIcon
      {...rest}
      aria-busy
      $size={size}
      aria-label={`${name ? `${name} ` : ''}Loader`}
      aria-live="polite"
      className={className}
      role="alert"
    />
  );

  return isOverlaying ? <Overlay>{spinnerElement}</Overlay> : spinnerElement;
};

export default Spinner;
